"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicPlanIds = void 0;
// NOTE: keep here to avoid circular dependency between country-transform & get-location plans
exports.basicPlanIds = {
    AU: 'personal-v3-aud',
    CA: 'personal-v3-cad',
    EU: 'personal-v3-eur',
    GB: 'personal-v3-gbp',
    US: 'personal-v3-usd',
    AD: 'personal-v3-usd-medium',
    AF: 'personal-v3-usd-medium',
    AG: 'personal-v3-usd-medium',
    AL: 'personal-v3-usd-medium',
    AM: 'personal-v3-usd-medium',
    AO: 'personal-v3-usd-medium',
    AQ: 'personal-v3-usd-medium',
    AR: 'personal-v3-usd-medium',
    AW: 'personal-v3-usd-medium',
    AZ: 'personal-v3-usd-medium',
    BA: 'personal-v3-usd-medium',
    BB: 'personal-v3-usd-medium',
    BD: 'personal-v3-usd-medium',
    BF: 'personal-v3-usd-medium',
    BI: 'personal-v3-usd-medium',
    BJ: 'personal-v3-usd-medium',
    BM: 'personal-v3-usd-medium',
    BO: 'personal-v3-usd-medium',
    BQ: 'personal-v3-usd-medium',
    BR: 'personal-v3-usd-medium',
    BS: 'personal-v3-usd-medium',
    BT: 'personal-v3-usd-medium',
    BY: 'personal-v3-usd-medium',
    CD: 'personal-v3-usd-medium',
    CI: 'personal-v3-usd-medium',
    CL: 'personal-v3-usd-medium',
    CM: 'personal-v3-usd-medium',
    CN: 'personal-v3-usd-medium',
    CO: 'personal-v3-usd-medium',
    CR: 'personal-v3-usd-medium',
    CU: 'personal-v3-usd-medium',
    CV: 'personal-v3-usd-medium',
    CW: 'personal-v3-usd-medium',
    DO: 'personal-v3-usd-medium',
    DZ: 'personal-v3-usd-medium',
    EC: 'personal-v3-usd-medium',
    EG: 'personal-v3-usd-medium',
    EH: 'personal-v3-usd-medium',
    ET: 'personal-v3-usd-medium',
    FJ: 'personal-v3-usd-medium',
    FK: 'personal-v3-usd-medium',
    FM: 'personal-v3-usd-medium',
    FO: 'personal-v3-usd-medium',
    GA: 'personal-v3-usd-medium',
    GD: 'personal-v3-usd-medium',
    GE: 'personal-v3-usd-medium',
    GG: 'personal-v3-usd-medium',
    GH: 'personal-v3-usd-medium',
    GI: 'personal-v3-usd-medium',
    GM: 'personal-v3-usd-medium',
    GP: 'personal-v3-usd-medium',
    GQ: 'personal-v3-usd-medium',
    GR: 'personal-v3-usd-medium',
    GT: 'personal-v3-usd-medium',
    GU: 'personal-v3-usd-medium',
    HK: 'personal-v3-usd-medium',
    HN: 'personal-v3-usd-medium',
    HR: 'personal-v3-usd-medium',
    HT: 'personal-v3-usd-medium',
    ID: 'personal-v3-usd-medium',
    IL: 'personal-v3-usd-medium',
    IN: 'personal-v3-usd-medium',
    IQ: 'personal-v3-usd-medium',
    IR: 'personal-v3-usd-medium',
    IS: 'personal-v3-usd-medium',
    JE: 'personal-v3-usd-medium',
    JM: 'personal-v3-usd-medium',
    JO: 'personal-v3-usd-medium',
    JP: 'personal-v3-usd-medium',
    KE: 'personal-v3-usd-medium',
    KG: 'personal-v3-usd-medium',
    KH: 'personal-v3-usd-medium',
    KN: 'personal-v3-usd-medium',
    KR: 'personal-v3-usd-medium',
    KY: 'personal-v3-usd-medium',
    LA: 'personal-v3-usd-medium',
    LB: 'personal-v3-usd-medium',
    LC: 'personal-v3-usd-medium',
    LI: 'personal-v3-usd-medium',
    LK: 'personal-v3-usd-medium',
    LS: 'personal-v3-usd-medium',
    LT: 'personal-v3-usd-medium',
    LV: 'personal-v3-usd-medium',
    LY: 'personal-v3-usd-medium',
    MA: 'personal-v3-usd-medium',
    MC: 'personal-v3-usd-medium',
    MD: 'personal-v3-usd-medium',
    ME: 'personal-v3-usd-medium',
    MG: 'personal-v3-usd-medium',
    MK: 'personal-v3-usd-medium',
    ML: 'personal-v3-usd-medium',
    MM: 'personal-v3-usd-medium',
    MN: 'personal-v3-usd-medium',
    MO: 'personal-v3-usd-medium',
    MQ: 'personal-v3-usd-medium',
    MR: 'personal-v3-usd-medium',
    MT: 'personal-v3-usd-medium',
    MU: 'personal-v3-usd-medium',
    MV: 'personal-v3-usd-medium',
    MW: 'personal-v3-usd-medium',
    MX: 'personal-v3-usd-medium',
    MY: 'personal-v3-usd-medium',
    MZ: 'personal-v3-usd-medium',
    NA: 'personal-v3-usd-medium',
    NC: 'personal-v3-usd-medium',
    NE: 'personal-v3-usd-medium',
    NF: 'personal-v3-usd-medium',
    NG: 'personal-v3-usd-medium',
    NI: 'personal-v3-usd-medium',
    NP: 'personal-v3-usd-medium',
    NZ: 'personal-v3-usd-medium',
    PA: 'personal-v3-usd-medium',
    PE: 'personal-v3-usd-medium',
    PF: 'personal-v3-usd-medium',
    PG: 'personal-v3-usd-medium',
    PH: 'personal-v3-usd-medium',
    PK: 'personal-v3-usd-medium',
    PR: 'personal-v3-usd-medium',
    PS: 'personal-v3-usd-medium',
    PY: 'personal-v3-usd-medium',
    RE: 'personal-v3-usd-medium',
    RS: 'personal-v3-usd-medium',
    RU: 'personal-v3-usd-medium',
    RW: 'personal-v3-usd-medium',
    SC: 'personal-v3-usd-medium',
    SD: 'personal-v3-usd-medium',
    SG: 'personal-v3-usd-medium',
    SI: 'personal-v3-usd-medium',
    SK: 'personal-v3-usd-medium',
    SL: 'personal-v3-usd-medium',
    SM: 'personal-v3-usd-medium',
    SN: 'personal-v3-usd-medium',
    SO: 'personal-v3-usd-medium',
    SS: 'personal-v3-usd-medium',
    SV: 'personal-v3-usd-medium',
    SY: 'personal-v3-usd-medium',
    SZ: 'personal-v3-usd-medium',
    TD: 'personal-v3-usd-medium',
    TG: 'personal-v3-usd-medium',
    TH: 'personal-v3-usd-medium',
    TJ: 'personal-v3-usd-medium',
    TL: 'personal-v3-usd-medium',
    TN: 'personal-v3-usd-medium',
    TR: 'personal-v3-usd-medium',
    TV: 'personal-v3-usd-medium',
    TW: 'personal-v3-usd-medium',
    TZ: 'personal-v3-usd-medium',
    UA: 'personal-v3-usd-medium',
    UG: 'personal-v3-usd-medium',
    UY: 'personal-v3-usd-medium',
    UZ: 'personal-v3-usd-medium',
    VC: 'personal-v3-usd-medium',
    VE: 'personal-v3-usd-medium',
    VG: 'personal-v3-usd-medium',
    VI: 'personal-v3-usd-medium',
    VN: 'personal-v3-usd-medium',
    VU: 'personal-v3-usd-medium',
    XK: 'personal-v3-usd-medium',
    YE: 'personal-v3-usd-medium',
    YT: 'personal-v3-usd-medium',
    ZA: 'personal-v3-usd-medium',
    ZM: 'personal-v3-usd-medium',
    ZW: 'personal-v3-usd-medium',
    AE: 'personal-v3-usd',
    BH: 'personal-v3-usd',
    BN: 'personal-v3-usd',
    BW: 'personal-v3-usd',
    BZ: 'personal-v3-usd',
    EE: 'personal-v3-usd',
    GY: 'personal-v3-usd',
    KW: 'personal-v3-usd',
    KZ: 'personal-v3-usd',
    LU: 'personal-v3-usd',
    OM: 'personal-v3-usd',
    QA: 'personal-v3-usd',
    SA: 'personal-v3-usd',
    SR: 'personal-v3-usd',
    TM: 'personal-v3-usd',
    TT: 'personal-v3-usd',
    AT: 'personal-v3-eur',
    BE: 'personal-v3-eur',
    CY: 'personal-v3-eur',
    DK: 'personal-v3-eur',
    FI: 'personal-v3-eur',
    FR: 'personal-v3-eur',
    DE: 'personal-v3-eur',
    IT: 'personal-v3-eur',
    IE: 'personal-v3-eur',
    NL: 'personal-v3-eur',
    NO: 'personal-v3-eur',
    PL: 'personal-v3-eur',
    ES: 'personal-v3-eur',
    SE: 'personal-v3-eur',
    CH: 'personal-v3-eur',
    CZ: 'personal-v3-eur',
    HU: 'personal-v3-eur',
    PT: 'personal-v3-eur',
    BG: 'personal-v3-eur',
    RO: 'personal-v3-eur',
};
//# sourceMappingURL=data:application/json;base64,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